/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

//Jacques Bega
//hook that grabs list of impounds on loan
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { fetchImpoundListData } from '../queryFunctions';

const useImpoundList = (loanNumber: string, token: string) => {
  return useQuery({
    queryKey: [loanNumber, token, 'impoundListData'],
    queryFn: ({ signal }: QueryFunctionContext) => fetchImpoundListData(signal, loanNumber, token),
    refetchOnWindowFocus: false,
  });
};

export default useImpoundList;
